import { Request } from '../../httpClient/serverApi/requests/Request';
import { IContent } from '../../ts/ServerApi/types/IContent';
import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../ts/ServerApi/types/IUser';

export interface ExploreContentParams extends IGetItemsParams {
  project?: string;
}

export interface IExploreContentResult extends IGetItemsResult {
  content: IContent[];
  users: IUser[];
}

export class ExploreFavoritedContentForUserRequest extends Request<ExploreContentParams, IExploreContentResult> {
  constructor(params: ExploreContentParams) {
    super('exploreFavoritedContentForUser', params);
  }
}
